import { sanitizeHtml } from "@/lib/sanitize";
import { Clock, GraduationCap, Award, ArrowLeft } from "lucide-react";
import { Level } from "@/routes/courses/enums/level.ts";
import { TimeHelper } from "@/services/helpers/timeHelpers.ts";
import { ConstantHelper } from "@/services/helpers/constantHelper.ts";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";

type CouseHeaderProps = {
  name: string;
  description: string;
  level: Level;
  durationMinute: number;
  isCertified: boolean;
};
const CourseHeader = ({
  name,
  description,
  level,
  durationMinute,
  isCertified,
}: CouseHeaderProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <div className="mb-8">
      <div className="flex items-center gap-3 mb-2">
        <Button
          variant="ghost"
          size="icon"
          onClick={() => navigate(-1)}
          className="shrink-0"
        >
          <ArrowLeft className="h-5 w-5" />
        </Button>
        <h1 className="text-3xl font-bold text-orange-500">{name}</h1>
      </div>
      <div
        className="text-muted-foreground mb-6 course-description break-words"
        dangerouslySetInnerHTML={{ __html: sanitizeHtml(description) }}
      />
      <div className="flex gap-6 text-sm text-muted-foreground">
        <div className="flex items-center gap-2">
          <GraduationCap className="h-5 w-5" />
          {ConstantHelper.getLevelText(level)}
        </div>
        <div className="flex items-center gap-2">
          <Clock className="h-5 w-5" />
          {TimeHelper.convertMinuteToText(durationMinute)}
          {isCertified && (
            <TooltipProvider delayDuration={150}>
              <Tooltip>
                <TooltipTrigger asChild>
                  <div className="flex items-center gap-1.5 cursor-default text-sm font-medium text-primary shrink-0">
                    <Award className="h-5 w-5" />
                    {t("course.certified")}
                  </div>
                </TooltipTrigger>
                <TooltipContent>
                  <p>{t("course.certificateTooltip")}</p>
                </TooltipContent>
              </Tooltip>
            </TooltipProvider>
          )}
        </div>
      </div>
    </div>
  );
};
export default CourseHeader;
